/**
 * Formats a computed calculation-variable value for pill/preview display.
 * Pure and dependency-free (mirrors the "no app imports" rule on
 * evaluate-formula.ts) so it can travel with the evaluator if it's ever
 * copied into the static-library runtime.
 *
 * Rounds to a fixed number of decimals (avoids float artifacts like
 * `0.1 + 0.2 === 0.30000000000000004`) then strips trailing zeros/dot.
 */
export const formatCalcNumber = (value: number, maxDecimals = 4): string => {
  if (!Number.isFinite(value)) return "";
  if (Number.isInteger(value)) return String(value);

  const rounded = value.toFixed(maxDecimals);
  return rounded.replace(/\.?0+$/, "");
};
